/** @format — Tool-call status during AG-UI stream (no chat bubble wrapper) */

import React from "react";
import { filterVisibleStreamTools, isHiddenStreamTool } from "@/features/chat-agui/streamingUtils";
import TypingDots from "./TypingDots";

const TOOL_LABELS = {
  transfer_to_agent: "Routing your request",
  get_shipping_quote_by_details: "Getting shipping quotes",
  get_shipping_quote: "Getting shipping quotes",
  get_location_from_zip: "Looking up pickup location",
  get_current_user_profile: "Loading your profile",
  initiate_vehicle_posting_payment: "Preparing payment",
  create_shipment_unified: "Creating your shipment",
  search_user_shipments: "Searching your shipments",
  search_user_bookings_advanced: "Searching bookings",
  get_saved_tracking_state_for_agent: "Loading tracking",
  summarize_tracking_state: "Summarizing tracking",
};

function labelForTool(name) {
  if (!name) return "Working";
  return TOOL_LABELS[name] ?? name.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

export default function StreamToolCalls({ tools = [], activeTool }) {
  const visible = filterVisibleStreamTools(tools);
  const list =
    visible.length > 0
      ? visible
      : activeTool && !isHiddenStreamTool(activeTool)
        ? [{ name: activeTool, status: "running" }]
        : [];

  if (!list.length) return null;

  return (
    <ul className="flex flex-col gap-1.5 min-w-0">
      {list.map((t) => (
        <li
          key={t.id ?? t.name}
          className="inline-flex items-center gap-2 w-fit max-w-full rounded-full bg-[#F2F4F7] border border-[#E4E7EC] px-3 py-1.5 text-[12px] text-[#475467]"
        >
          {t.status === "running" ? (
            <TypingDots />
          ) : (
            <span className="h-2 w-2 rounded-full bg-[#12B76A] animate-pulse flex-shrink-0" aria-hidden />
          )}
          <span className="truncate">{labelForTool(t.name)}</span>
        </li>
      ))}
    </ul>
  );
}
